import { api } from '../../../lib/api'

export const GET_CATEGORIES_REQUEST = 'GET_CATEGORIES_REQUEST'
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS'
export const GET_CATEGORIES_FAILED = 'GET_CATEGORIES_FAILED'

export const GET_CATEGORIES_DOMAIN_REQUEST = 'GET_CATEGORIES_DOMAIN_REQUEST'
export const GET_CATEGORIES_DOMAIN_FAILED = 'GET_CATEGORIES_DOMAIN_FAILED'

export const GET_CATEGORIES_FURNITURE_SUCCESS = 'GET_CATEGORIES_FURNITURE_SUCCESS'
export const GET_CATEGORIES_HOME_DECO_SUCCESS = 'GET_CATEGORIES_HOME_DECO_SUCCESS'
export const GET_CATEGORIES_REAL_ESTATE_SUCCESS = 'GET_CATEGORIES_REAL_ESTATE_SUCCESS'

export const getCategories = function (domainConstant, onComplete) {
  return function (dispatch) {
    dispatch({
      type: GET_CATEGORIES_REQUEST
    })
    return api.getCategories(domainConstant).then((getCategoriesResponse) => {
      dispatch({
        type: GET_CATEGORIES_SUCCESS,
        payload: getCategoriesResponse
      })
      if (onComplete) {
        onComplete(getCategoriesResponse.data.payload)
      }
    }).catch((error) => {
      dispatch({
        type: GET_CATEGORIES_FAILED,
        error
      })
    })
  }
}

export const getCategoriesDomain = function (domainConstant, onComplete) {
  return function (dispatch) {
    dispatch({
      type: GET_CATEGORIES_DOMAIN_REQUEST
    })
    api.getCategories(domainConstant).then((getCategoriesResponse) => {
      console.log(domainConstant)
      switch (domainConstant) {
        case 'FURNITURE':
          dispatch({
            type: GET_CATEGORIES_FURNITURE_SUCCESS,
            payload: getCategoriesResponse
          })
          break;
        case 'HOME_DECO':
          dispatch({
            type: GET_CATEGORIES_HOME_DECO_SUCCESS,
            payload: getCategoriesResponse
          })
          break;
        case 'REAL_ESTATE':
          dispatch({
            type: GET_CATEGORIES_REAL_ESTATE_SUCCESS,
            payload: getCategoriesResponse
          })
          break;
        default: break;
      }
      if (onComplete) {
        onComplete(getCategoriesResponse.data.payload)
      }
    }).catch((error) => {
      dispatch({
        type: GET_CATEGORIES_DOMAIN_FAILED,
        error
      })
    })

  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/category/get-categories.js